import {
  DRAW_ON_MAP,
  SELECT_GEOMETRY,
  SELECT_POPUP_EDIT_GEOMETRY,
} from '../actions/actions_map'

const mapActions = (state = {
  draw : false,
  selectGeometry : false,
  popupEditGeometry : false
}, action) => {
  var stateCopy = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case DRAW_ON_MAP:
      stateCopy['draw'] = action.payload;
      return stateCopy;
    case SELECT_GEOMETRY:
      stateCopy['selectGeometry'] = action.payload;
      return stateCopy;
    case SELECT_POPUP_EDIT_GEOMETRY:
      stateCopy['popupEditGeometry'] = action.payload;
      return stateCopy;
    default:
      return state
  }
}

export default mapActions



// WEBPACK FOOTER //
// ./src/reducers/reducer_map.js